document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
});

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  items.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var main = document.querySelector('[data-mt-gallery-main]');
  var thumbs = document.querySelectorAll('[data-mt-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!full) return;
      main.src = full;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('mt-activa'); });
      thumb.classList.add('mt-activa');
    });
  });
}

function initVariantes() {
  var select = document.querySelector('[data-mt-variant-select]');
  if (!select) return;
  var form = document.querySelector('[data-mt-product-form]');
  if (!form) return;
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-mt-price]');
  var compareEl = document.querySelector('[data-mt-price-compare]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var stockEl = document.querySelector('[data-mt-stock]');
  var variants = [];
  try {
    variants = JSON.parse(document.querySelector('[data-mt-variants-json]').textContent);
  } catch (e) {
    return;
  }

  select.addEventListener('change', function () {
    var variant = variants.find(function (v) { return String(v.id) === select.value; });
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (variant.available) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-label-disponible') || submitBtn.textContent;
      if (stockEl) { stockEl.textContent = stockEl.getAttribute('data-label-disponible') || ''; stockEl.classList.remove('mt-producto__stock--agotado'); }
    } else {
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.getAttribute('data-label-agotado') || 'Agotado';
      if (stockEl) { stockEl.textContent = stockEl.getAttribute('data-label-agotado') || 'Agotado'; stockEl.classList.add('mt-producto__stock--agotado'); }
    }
  });
}

function formatMoney(cents) {
  var value = (cents / 100).toFixed(2);
  return (window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active + ' ' : '') + value;
}
